import SEOHead from '../../components/SEOHead';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import AboutSection from './components/AboutSection';
import WhyChooseUs from './components/WhyChooseUs';
import Gallery from './components/Gallery';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://lbaconstruct.be';
  
  const structuredData = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "LocalBusiness",
        "@id": `${siteUrl}/#organization`,
        "name": "LBA Construct",
        "url": siteUrl,
        "logo": `${siteUrl}/vite.svg`,
        "image": "https://public.readdy.ai/ai/img_res/9f17768f-557a-422c-acf8-71d99eebfaaf.png",
        "description": "LBA Construct is uw specialist in dakwerken, zolder isolatie, gyproc werken en loodgieterij in Merksem en omgeving.",
        "address": {
          "@type": "PostalAddress",
          "addressLocality": "Merksem",
          "addressRegion": "Antwerpen",
          "addressCountry": "BE"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "51.2467",
          "longitude": "4.4481"
        },
        "areaServed": {
          "@type": "City",
          "name": "Merksem"
        },
        "priceRange": "€€",
        "telephone": "+32-XXX-XX-XX-XX",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "08:00",
            "closes": "18:00"
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": `${siteUrl}/#website`,
        "url": siteUrl,
        "name": "LBA Construct",
        "description": "Professionele dakwerken en renovatie in Merksem",
        "publisher": {
          "@id": `${siteUrl}/#organization`
        },
        "inLanguage": "nl-BE"
      },
      {
        "@type": "WebPage",
        "@id": `${siteUrl}/#webpage`,
        "url": siteUrl,
        "name": "Merksem Dakwerken Renovatie LBA Construct | Professionele Bouwdiensten",
        "isPartOf": {
          "@id": `${siteUrl}/#website`
        },
        "about": {
          "@id": `${siteUrl}/#organization`
        },
        "description": "LBA Construct is uw specialist in dakwerken, zolder isolatie, gyproc werken en loodgieterij in Merksem en omgeving. Vakmanschap en kwaliteit gegarandeerd.",
        "inLanguage": "nl-BE"
      },
      {
        "@type": "Service",
        "serviceType": "Dakwerken",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Merksem"
        },
        "description": "Hellende daken en platte daken. Van dakpannen plaatsen tot EPDM dakbedekking."
      },
      {
        "@type": "Service",
        "serviceType": "Zolder Isolatie",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Merksem"
        },
        "description": "Professionele isolatie van uw zolder voor optimale energiebesparing."
      },
      {
        "@type": "Service",
        "serviceType": "Gyproc & Bezetting",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Merksem"
        },
        "description": "Gyproc werken en kleine bezettingen voor binnenmuren en plafonds."
      },
      {
        "@type": "Service",
        "serviceType": "Loodgieterij",
        "provider": {
          "@id": `${siteUrl}/#organization`
        },
        "areaServed": {
          "@type": "City",
          "name": "Merksem"
        },
        "description": "Complete loodgietersdiensten voor uw woning of bedrijf."
      }
    ]
  };

  return (
    <>
      <SEOHead
        title="Merksem Dakwerken Renovatie LBA Construct | Professionele Bouwdiensten"
        description="LBA Construct is uw specialist in dakwerken, zolder isolatie, gyproc werken en loodgieterij in Merksem en omgeving. Vakmanschap en kwaliteit gegarandeerd. Vraag nu een gratis offerte aan voor uw bouw- of renovatieproject."
        keywords="dakwerken Merksem, zolder isolatie, gyproc werken, loodgieterij, renovatie"
        canonical={siteUrl}
        ogImage="https://public.readdy.ai/ai/img_res/9f17768f-557a-422c-acf8-71d99eebfaaf.png"
        structuredData={structuredData}
      />
      <Header />
      <Hero />
      <Services />
      <AboutSection />
      <WhyChooseUs />
      <Gallery />
      <CTASection />
      <ContactSection />
      <Footer />
    </>
  );
}
